module.exports = __webpack_public_path__ + "static/media/setup_img2.f9bddd38.png";